import { OnInit, Input, Output, EventEmitter, Component } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';

@Component({
  selector: 'iw-button-view-form-dynamic',
  template: '<p>{{ coordinates }}</p>',
  styles: [`
        .btn-xs {
          font: 400 10.3333px Arial !important;
        }
    `]
})
export class CoordinateDynamicFormsComponent implements ViewCell, OnInit {
  // entrada del valor del label
  @Input() value: any;
  // entrada de la fila
  @Input() rowData: any;
  // cadena de coordenadas
  coordinates = '';

  ngOnInit() {
    this.loadingCoordinates();
  }

  /**
   * Crea la cadena con las coordenadas ingresadas
   *
   * @memberof CoordinateDynamicFormsComponent
   */
  loadingCoordinates() {
    if (this.value['latitud']) {
      this.coordinates += 'latitud: ' + this.value['latitud'];
    }

    if (this.value['longitud']) {
      if (this.coordinates !== '') {
        this.coordinates += ', ';
      }
      this.coordinates += 'Longitud: ' + this.value['longitud'];
    }

    if (this.value['altura']) {
      if (this.coordinates !== '') {
        this.coordinates += ', ';
      }
      this.coordinates += 'Altura: ' + this.value['altura'];
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/component-table/coordinates-dynamic-forms.component.ts